import React from 'react';
import '../layout/sec5.css';
import Btn1 from '../common/btn1';

const Sec5Card = (props) => {
    return (
        <div className='sec5card'>
            <div className='sec5card-img-wrap'>
                <img className='sec5card-img' src={props.image} alt={props.title} />
                {props.badge && <span className='sec5card-badge'>{props.badge}</span>}
                {props.showFreeBadge && <span className='sec5card-free-badge'>FREE</span>}
            </div>

            <div className='sec5card-body'>
                <h3 className='sec5card-title'>{props.title}</h3>
                <p className='sec5card-desc'>{props.desc}</p>

                <div className='sec5card-meta'>
                    <div className='sec5card-meta-item'>
                        <img className='sec5card-meta-icon' src={props.icon1} alt='date' />
                        <span>{props.date}</span>
                    </div>
                    <div className='sec5card-meta-item'>
                        <img className='sec5card-meta-icon' src={props.icon2} alt='time' />
                        <span>{props.time}</span>
                    </div>
                    <div className='sec5card-meta-item'>
                        <img className='sec5card-meta-icon' src={props.icon3} alt='location' />
                        <span>{props.location}</span>
                    </div>
                </div>

                <div className='sec5card-footer'>
                    <div className='sec5card-price-wrap'>
                        <span className='sec5card-from'>From</span>
                        <span className={`sec5card-price ${props.isFree ? 'free' : ''}`}>
                            {props.isFree ? 'FREE' : `$${props.price}`}
                        </span>
                    </div>

                    <Btn1 b={props.b} btntt={props.btntt} ic={props.ic} />
                </div>
            </div>
        </div>
    );
};

export default Sec5Card;